import { canonicalWorkAreaKey } from "./work-area-keys";

/** Client groups provide context, never evidence of a particular topic. */
export function isClientGroupFocusArea(key: string): boolean {
  return key.startsWith("work_with_") || key === "adolescents";
}

export const FOCUS_AREAS = [
  "anxiety",
  "stress",
  "emotional_regulation",
  "self_esteem",
  "relationships",
  "couples_issues",
  "family_issues",
  "parenting",
  "non_monogamy",
  "adoption",
  "self_development",
  "life_crises",
  "grief_loss",
  "work_issues",
  "procrastination",
  "migration_adjustment",
  "lgbtq",
  "discrimination",
  "violence_abuse",
  "chronic_illness",
  "depression",
  "chronic_pain",
  "perinatal",
  "infertility",
  "pregnancy_loss",
  "sexual_difficulties",
  "sleep_problems",
  "psychosomatic",
  "obesity_support",
  "learning_difficulties",
  "childhood_development",
  "behavioral_difficulties",
  "intrusive_thoughts",
  "trauma",
  "ptsd",
  "complex_ptsd",
  "dissociation",
  "ocd",
  "hoarding",
  "adhd",
  "autism",
  "bipolar",
  "psychotic_experiences",
  "suicidality",
  "self_destructive_behavior",
  "personality_disorders",
  "bpd",
  "eating_disorders",
  "anorexia",
  "bulimia",
  "binge_eating",
  "arfid",
  "body_dysmorphia",
  "hair_pulling",
  "skin_picking",
  "addictions",
  "gambling",
  "substance_addictions",
  "problematic_internet_use",
  "problematic_pornography_use",
  "work_with_adults",
  "work_with_adolescents",
  "work_with_children",
  "work_with_parents",
  "work_with_couples",
  "work_with_lgbtq",
  "work_with_older_adults",
  "work_with_disabled_people",
  "work_with_neurodivergent_people",
  "work_with_students",
  "work_with_people_abroad",
  "work_with_caregivers",
  "work_with_perinatal_clients",
] as const;

export type SeedFocusArea = (typeof FOCUS_AREAS)[number];
/** Catalog keys are extensible without a deployment. */
export type FocusArea = string;
export const FOCUS_AREA_KEY_PATTERN = /^[a-z][a-z0-9_]{1,79}$/;

const MAX_FOCUS_AREAS = 6;

export function sanitizeFocusAreas(
  raw: string[],
  catalogKeys: readonly string[] = FOCUS_AREAS,
): FocusArea[] {
  const allowed = new Set(catalogKeys);
  const seen = new Set<string>();
  const result: FocusArea[] = [];
  for (const rawValue of raw) {
    const value = canonicalWorkAreaKey(rawValue);
    if (!allowed.has(value) || seen.has(value)) continue;
    seen.add(value);
    result.push(value);
    if (result.length === MAX_FOCUS_AREAS) break;
  }
  return result;
}

export const MODALITIES = [
  "kbt",
  "rebt",
  "gestalt",
  "act",
  "cft",
  "dbt",
  "psychodynamic",
  "integrative",
  "systemic",
  "emdr",
  "mindfulness",
  "other",
  "unknown",
] as const;

export type Modality = (typeof MODALITIES)[number];
